<template>
  <div @click="handlePlanClick(guide, plan)" class="plan">
    <div class="plan-header">
      <div class="plan-name">
        <h4>{{ plan.title }}</h4>
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.92944 5.11759C5.92945 7.96936 9.74295 11.4802 11.9932 12.9116C14.4128 11.3528 18.0271 8.6764 18.0271 5.44116C18.0271 3.90472 17.131 2 15.279 2C13.7974 2 12.6205 2.64709 11.9932 3.8235C11.3361 2.61768 9.60355 2 8.76717 2C7.93079 2 5.92944 2 5.92944 5.11759Z"
              stroke="#B3C2CB"
            />
            <path
              d="M7.72155 17.8233C7.67176 17.5586 7.15401 16.6762 7.15401 16.6762L5.45137 15.0586C5.45137 15.0586 4.55525 14.1175 4.01758 13.4998C3.4799 12.8822 3.43016 12.3234 3.56956 11.9704C3.65425 11.756 3.95788 11.5881 4.07736 11.5881M4.07736 11.5881C4.22672 11.5587 4.61504 11.6176 4.85396 11.8528C5.12284 12.1175 6.40724 13.3822 7.15401 14.1175C7.90078 14.8528 10.2905 15.8233 10.7087 16.8527C11.1269 17.8821 10.8282 20.3821 10.8282 22.0879L6.67608 22.1173C6.80552 21.6467 6.67608 20.6762 6.67608 19.8232C6.67608 18.502 5.15271 17.3821 4.67478 17.0292C4.19686 16.6762 2.16558 15.0586 2.16558 14.1175C2.16557 12.2902 1.89441 8.76154 2.04612 7.52935C2.16561 6.55878 2.28506 6.02936 2.82274 6.23524C3.36041 6.44112 3.59938 6.87054 3.59938 7.647C3.59938 8.42346 3.93797 10.5999 4.07736 11.5881Z"
              stroke="#B3C2CB"
            />
            <path
              d="M16.2785 17.8233C16.3282 17.5586 16.846 16.6762 16.846 16.6762L18.5486 15.0586C18.5486 15.0586 19.4447 14.1175 19.9824 13.4998C20.5201 12.8822 20.5698 12.3234 20.4304 11.9704C20.3458 11.756 20.0421 11.5881 19.9226 11.5881M19.9226 11.5881C19.7733 11.5587 19.385 11.6176 19.146 11.8528C18.8772 12.1175 17.5928 13.3822 16.846 14.1175C16.0992 14.8528 13.7095 15.8233 13.2913 16.8527C12.8731 17.8821 13.1718 20.3821 13.1718 22.0879L17.3239 22.1173C17.1945 21.6467 17.3239 20.6762 17.3239 19.8232C17.3239 18.502 18.8473 17.3821 19.3252 17.0292C19.8031 16.6762 21.8344 15.0586 21.8344 14.1175C21.8344 12.2902 22.1056 8.76154 21.9539 7.52935C21.8344 6.55878 21.7149 6.02936 21.1773 6.23524C20.6396 6.44112 20.4006 6.87054 20.4006 7.647C20.4006 8.42346 20.062 10.5999 19.9226 11.5881Z"
              stroke="#B3C2CB"
            />
          </svg>
        </span>
        <span class="price"> ${{ plan.price }} </span>
        <span class="session"> /{{ plan.duration }} minutes </span>
      </div>
      <div class="buttons">
        <b-button
          v-if="plan.videoURL"
          class="play-btn"
          @click="$bvModal.show('video-modal')"
        >
          <span>
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.0001 2.75002C6.44373 2.75002 2.75008 6.44367 2.75008 11C2.75008 15.5564 6.44373 19.25 11.0001 19.25C15.5564 19.25 19.2501 15.5564 19.2501 11C19.2501 6.44367 15.5564 2.75002 11.0001 2.75002ZM0.916748 11C0.916748 5.43115 5.43121 0.916687 11.0001 0.916687C16.569 0.916687 21.0834 5.43115 21.0834 11C21.0834 16.5689 16.569 21.0834 11.0001 21.0834C5.43121 21.0834 0.916748 16.5689 0.916748 11Z"
              />
              <!-- fill="#557EFB" -->
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.73413 6.52515C9.03219 6.36564 9.39386 6.38312 9.67514 6.57064L15.1751 10.2373C15.4302 10.4073 15.5833 10.6935 15.5833 11C15.5833 11.3065 15.4302 11.5927 15.1751 11.7627L9.67514 15.4294C9.39386 15.6169 9.03219 15.6344 8.73413 15.4749C8.43607 15.3154 8.25 15.0048 8.25 14.6667V7.33336C8.25 6.99529 8.43607 6.68467 8.73413 6.52515ZM10.0833 9.04616V12.9539L13.0141 11L10.0833 9.04616Z"
              />
              <!-- fill="#557EFB" -->
            </svg>
          </span>
          PLAY
        </b-button>
        <b-button
          variant="primary book"
          v-b-toggle.guide_book
          @click.stop="$emit('plan-selected', plan)"
        >
          BOOK
        </b-button>
      </div>
    </div>
    <div class="plan-info">
      <p v-if="plan.details.length > 250">
        {{ plan.details.slice(0, 250) }}
        <span v-if="show" class="read-more">
          {{ plan.details.slice(250, plan.details.length) }}
          <a @click.stop="show = !show">Read Less</a>
        </span>
        <a @click.stop="show = !show" v-if="!show">Read More</a>
      </p>
      <p v-else>
        {{ plan.details }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  props: ["plan", "guide"],
  methods: {
    handlePlanClick(guide, plan) {
      this.$router.push(
        `/guide/@${guide.profile.profileName}/plan/${
          plan.slug ? plan.slug : plan.title
        }`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.plan {
  cursor: pointer;
  max-width: 835px;
  width: 100%;
  padding: 24px;
  background-color: #557efb;
  background: #ffffff;
  /* border:1px solid #000; */
  font-family: "Nunito", sans-serif;
  margin-bottom: 24px;
  filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04));
  border-radius: 8px;
  &:hover {
    box-shadow: 0px 12px 16px rgba(45, 38, 38, 0.1);
  }
}
.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.buttons {
  display: flex;
  align-items: center;
}
.play-btn {
  display: flex;
  align-items: center;
  box-shadow: none;
  justify-content: center;
  padding: 0 !important;
  width: 104px;
  height: 40px;
  border: 1px solid #557efb;
  box-sizing: border-box;
  border-radius: 32px;
  color: #557efb;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  background: none;
  margin-right: 15px;
  transition: 0.3s linear;
  path {
    fill: #557efb;
    transition: 0.3s linear;
  }
  &.btn {
    &::after,
    &::before {
      content: none;
    }
    &:hover {
      transform: none !important;
      box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
    }
  }
}
.play-btn:hover {
  box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
  color: #fff;
  background-color: #557efb;
  path {
    fill: #fff;
  }
}
.play-btn span {
  padding-right: 10px;
}
.plan .plan-name {
  text-align: left;
}
.plan .plan-name h4 {
  font-weight: bold;
  font-size: 20px;
  color: #52595e;
  text-align: center;
}

.plan-name .price,
.plan-name .session {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.plan-name .session {
  opacity: 0.5;
}
.plan-name .price {
  color: #557efb;
}
.book {
  margin-left: 14px;
  text-align: center;
  background: #557efb;
  border-radius: 100px;
  color: #fff;
  padding: 9px 44px;
  // filter: drop-shadow(0px 4px 12px rgba(18, 77, 255, 0.14));
  box-shadow: none;
  transition: 0.3s linear;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  border: none;
  outline: none;
  text-transform: uppercase;
  &.btn {
    &::after,
    &::before {
      content: none;
    }
    &:hover {
      // transform: none !important;
      // box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
    }
  }
}
.book:hover,
.book:focus {
  box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75) !important;
  transform: none !important;
}
.plan-info {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #474d52;
  margin-top: 17px;
  .read-more {
    position: absolute;
  }
}
.plan-info a {
  color: #557efb;
  text-decoration: underline;
  cursor: pointer;
}
.plan-info p {
  text-align: left;
  color: #474d52;
}
@media (max-width: 768px) {
  .plan-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons {
    margin: 10px 0;
  }
}
@media (max-width: 500px) {
  .plan {
    padding: 10px;
  }
  .book {
    margin-left: 0px;
    padding: 7px 15px;
    font-size: 12px;
  }
  .play-btn {
    width: 88px;
    height: 32px;
  }
}
</style>
